import { writable } from 'svelte/store';
import { VehiclesApp } from './VehiclesApp';

export let vehiclesManager = writable<VehiclesApp>(new VehiclesApp());
